import { ApiProductCard } from '../../api';

class ProductItemListEvent {
  items: Array<ApiProductCard>;
}

export default ProductItemListEvent;
